import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, Box, TextField } from "@material-ui/core";
import { Button } from "components";
import { usePopup } from "hooks/usePopup";
import { forwardRef, useState, useImperativeHandle } from "react";
import { useForm } from "react-hook-form";
import storageService from "services/storageService";
import { Dialog } from "shared";
import * as Yup from "yup";

export const Component = ({ refresh }, ref) => {
  const { addPopup } = usePopup();
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState({});

  const schema = Yup.object().shape({
    quantity: Yup.number()
      .positive("Quantidade não pode ser negativa")
      .max(
        data?.locked_stock,
        `A quantidade deve ser menor ou igual a ${new Intl.NumberFormat(
          "pt-BR"
        ).format(data?.locked_stock?.toFixed(2))}`
      )
      .typeError("Quantidade é obrigatória")
      .required("Quantidade é obrigatória")
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue
  } = useForm({ resolver: yupResolver(schema) });

  const toggleOpen = () => setIsOpen(state => !state);

  const handleData = data => {
    setData(data);
    setValue("quantity", data.locked_stock);
    toggleOpen();
  };

  useImperativeHandle(ref, () => ({ toggleOpen, handleData }));

  const handleClose = () => {
    toggleOpen();
    reset({ quantity: null });
  };

  const onSubmitHandler = async formData => {
    try {
      setIsLoading(true);
      const requestData = {
        quantity: formData.quantity
      };

      await storageService.unlockStorage(requestData, data.id);
      addPopup({
        type: "success",
        title: "Estoque desbloqueado com sucesso!"
      });
      refresh();
      handleClose();
    } catch (err) {
      if (err?.response?.status !== 401) {
        addPopup({
          type: "error",
          title: "Erro ao desbloquear estoque"
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} handleClose={handleClose} title="Desbloquear estoque">
      <Box component="form" onSubmit={handleSubmit(onSubmitHandler)} noValidate>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              {...register("quantity")}
              error={!!errors?.quantity}
              helperText={errors?.quantity?.message}
              style={{ width: "100%" }}
              variant="outlined"
              label="Quantidade"
              type="number"
            />
          </Grid>

          <Grid container item xs={12} justifyContent="flex-end">
            <Button
              isLoading={isLoading}
              type="submit"
              variant="contained"
              size="large"
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
};

export const Unlock = forwardRef(Component);
